import { Avatar, CheckboxSelectorInner } from '@Knowledge-OTP/znk-ui-components'
import React from 'react'
import useTranslation from '../../../i18n/useTranslation'

const CounselorFilter = (props) => {
  const { counselorFilters, setCounselorFilters, counselors = [] } = props
  const { translate } = useTranslation()

  const checkboxSelectorProps = {
    setDataFilters: setCounselorFilters,
    direction: 'bottomCenter',
    dataFilters: counselorFilters,
    typeFilter: 'statuses',
    data: counselors?.map((counselor) => ({
      name: `${counselor.firstName} ${counselor.lastName}`,
      id: counselor.id,
      Component: (
        <Avatar
          name={`${counselor.firstName} ${counselor.lastName}`}
          named={false}
          uri={null}
          size='avatar-small'
        />
      )
    })),
    strings: {
      title:"Student Success Coordinator",
      viewAll: translate('filters.plans.viewAll'),
      buttonCancel: translate('filters.plans.buttonCancel'),
      buttonApply: translate('filters.plans.buttonApply'),
      search: translate('filters.plans.search')
    }
  }

  return (
    <CheckboxSelectorInner style={{maxWidth: 'auto'}} {...checkboxSelectorProps}/>
  )
}

export default CounselorFilter
